import React from 'react'

import {ResponsePermalink, Recording} from './Recording.js'
import testData from './testData.json'


class App extends React.Component {
    constructor() {
        super()
        if (process.env.NODE_ENV === 'production') {
            this.data = JSON.parse(document.getElementById('data').textContent)
        } else {
            this.data = testData
        }
    }

    render() {
        // Render a different response based on url
        if (window.location.pathname.split('/')[1] === 'responses') {
            return <ResponsePermalink data={this.data} />
        } else {
            return <Recording data={this.data} />
        }
    }
}


export default App
